import React, { useEffect, useState } from 'react';
import useTables from '../components/hooks/useTables';
import FloorLayoutRenderer from '../components/FloorLayoutRenderer';
import WaiterLoginModal from '../components/WaiterLoginModal';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';



export default function TableServiceViewPage({ storeId }) {
  
  const { tables, fetchTables, updateTable } = useTables(storeId);

  const [selectedTable, setSelectedTable] = useState(null);
  const [waiterInfo, setWaiterInfo] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (storeId) fetchTables();
  }, [storeId]);

  const handleTableClick = (table) => {
    setSelectedTable(table);
    setShowLogin(true);
  };

  const handleWaiterLogin = async (waiter) => {
    if (!selectedTable) {
      console.error("No table selected!");
      return;
    }
  
    try {
      await updateTable(selectedTable._id, { status: 'occupied' });
      console.log('Table marked as occupied');
  
      navigate(`/orders/${storeId}/${selectedTable._id}`, {
        state: { 
          waiterInfo: waiter, 
          table: selectedTable,
          storeId: storeId,
        },
      });
    } catch (err) {
      console.error('Failed to update table status:', err);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center py-8">
      <h2 className="text-2xl font-bold mb-6">Table Service</h2>

      <FloorLayoutRenderer
        tables={tables}
        isDraggable={false}
        isInteractive={true}
        onTableClick={handleTableClick}
      />


      <WaiterLoginModal
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        onSuccess={handleWaiterLogin}
      />
    </div>
  );
}
